import { jsx as r, Fragment as e } from "react/jsx-runtime";
import { Skeleton as n, Box as s } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import { files as c } from "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { FileItem as f } from "../list/components/file.js";
import { useEffect as l } from "react";
const H = ({ taskId: p, onDataLoaded: i }) => {
  const { isPending: m, data: o } = new c.FileList({ FileType: 1, LinkID: p }).ToQuery();
  return l(() => {
    !m && i && i(o && o.length > 0 || !1);
  }, [m, o, i]), m ? /* @__PURE__ */ r(n, {}) : (o == null ? void 0 : o.length) == 0 ? /* @__PURE__ */ r(e, {}) : /* @__PURE__ */ r(s, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: o == null ? void 0 : o.map((t) => /* @__PURE__ */ r(
    f,
    {
      name: t.Name + "." + t.Ext,
      description: t.Description,
      extension: t.Ext,
      modified: t.Modified,
      download: !0,
      contentType: 0,
      fileId: t.FileID,
      pdf: t.Ext.toLowerCase() == "pdf",
      location: t.LocationType,
      path: t.Path
    },
    t.FileID
  )) });
};
export {
  H as TaskAttachments
};
//# sourceMappingURL=TaskAttachments.js.map
